const ADDRESS_FINDER_COMPONENT_NAME = 'AddressFinder';

const HERO_CARD_ADDRESS_FINDER_PLACEHOLDERS = ['jss-hero-card-main', 'jss-hero-card-top'] as const;

/**
 * Fallback until AddressFinder exposes `accessibilityIntro` in Sitecore.
 * Never returned unless AddressFinder is present in a HeroCard placeholder.
 */
export const ADDRESS_FINDER_ACCESSIBILITY_INTRO_FALLBACK =
  'Je bent op de pagina om je energiekosten te berekenen. Vul je postcode en huisnummer in. We gebruiken je adres om een persoonlijk aanbod te tonen.';

/**
 * Sitecore field on AddressFinder (not yet in the generated template).
 * Read only from that nested rendering — never from HeroCard itself.
 */
interface AddressFinderAccessibilityFields {
  accessibilityIntro?: {
    value?: string;
  };
}

interface PlaceholderRendering {
  componentName?: string;
  fields?: AddressFinderAccessibilityFields;
}

export const getAddressFinderAccessibilityIntro = (
  placeholders?: Record<string, PlaceholderRendering[] | undefined>,
): string | undefined => {
  if (!placeholders) return undefined;

  const addressFinder = HERO_CARD_ADDRESS_FINDER_PLACEHOLDERS.flatMap(name => placeholders[name] ?? []).find(
    item => item.componentName === ADDRESS_FINDER_COMPONENT_NAME,
  );

  if (!addressFinder) return undefined;

  const fromSitecore = addressFinder.fields?.accessibilityIntro?.value?.trim();
  return fromSitecore || ADDRESS_FINDER_ACCESSIBILITY_INTRO_FALLBACK;
};
